import { useEffect, useState } from 'react';

const readCssVariable = (variableName: string): string => {
  if (typeof window === 'undefined') return '';
  return getComputedStyle(document.documentElement)
    .getPropertyValue(variableName)
    .trim();
};

export function useCssVariableValue(variableName: string) {
  const [value, setValue] = useState(() => readCssVariable(variableName));

  useEffect(() => {
    const root = document.documentElement;

    const updateValue = () => {
      setValue(getComputedStyle(root).getPropertyValue(variableName).trim());
    };

    // Initial read
    updateValue();

    // Listen for prefers-color-scheme changes
    const darkModeMedia = window.matchMedia('(prefers-color-scheme: dark)');
    const lightModeMedia = window.matchMedia('(prefers-color-scheme: light)');

    const handleChange = () => updateValue();

    darkModeMedia.addEventListener('change', handleChange);
    lightModeMedia.addEventListener('change', handleChange);

    return () => {
      darkModeMedia.removeEventListener('change', handleChange);
      lightModeMedia.removeEventListener('change', handleChange);
    };
  }, [variableName]);

  return value;
}
